import { render } from "./barcodeComponent.vue?vue&type=template&id=58f2f786&scoped=true"
import script from "./barcodeComponent.vue?vue&type=script&lang=js"
export * from "./barcodeComponent.vue?vue&type=script&lang=js"

import "./barcodeComponent.vue?vue&type=style&index=0&id=58f2f786&scoped=true&lang=css"

import exportComponent from "F:\\workspace\\eduwind-front\\eduwind-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58f2f786"]])

export default __exports__